import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import {EditorDialog} from '../editor-components';
import ExhibitorSelect from './exhibitor-select';

/** @class CreateGiftCardDialog
  * A component for creating a new gift card.
  * @prop {Array} exhibitors - the exhibitors in the show
  * @prop {URL} dataURL - the Firebase url for gift cards
  * @prop {Ojbect} giftCard - the gift card being edited
  * @prop {bool} show - a boolean flag indicating if the dialog visibility
  */
export default class CreateGiftCardDialog extends Component {
  /** @constructor
    * Constructs a new CreateGiftCardDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      exhibitorID: '',
      deal: '',
      code: '',
      image: ''
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleSave
    * Applies the current state to the database,
    * clears the form, and closes the dialog.
    */
  handleSave(event) {
    event.preventDefault();
    const file = event.target.image && event.target.image.files && event.target.image.files[0];
    // TODO: Check file exists
    if(!file) {
      return;
    }
    // Determine the exhibitor
    const exhibitor = this.props.exhibitors.find(exhibitor => exhibitor.id === this.state.exhibitorID);
    if(!exhibitor) {
      return;
    }
    // Save to the firebase database
    const giftCard = {
      exhibitorID: this.state.exhibitorID,
      exhibitor: exhibitor.brand || exhibitor.company || "",
      deal: this.state.deal,
      code: this.state.code
    }
    firebase.database().ref(this.props.dataURL).push(giftCard)
    .then(databaseRef => {
      var storageRef = firebase.storage().ref().child(`${this.props.dataURL}/${databaseRef.key}`);
      // Save the image to firebase storage
      return storageRef.put(file).then(()=>{
        storageRef.getDownloadURL().then((url) => {
          databaseRef.child('image').set(url)
          .then(()=>{
            this.setState({
              exhibitorID: '',
              deal: '',
              code: ''
            });
            this.props.onExit();
          })
        })
      })
    })
  }
  /** @method render
    * Renders the component
    */
  render() {
    const style={maxWidth: "50vw"}
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Add New Gift Card</h3>
        <div className="input-group">
          <ExhibitorSelect
            value={this.state.exhibitorID}
            exhibitors={this.props.exhibitors}
            onChange={this.handleChange}
            />
        </div>
        <form onSubmit={this.handleSave} style={style}>
          <div className="input-group">
            <label htmlFor="deal">Deal</label>
            <input name="deal" type="text"
              value={this.state.deal}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              required
              minLength={1}/>
            <p className="hint">
              The deal being offered by this gift card, i.e. "$5 off a $25 purchase".
              Do <strong>NOT</strong> enter gift card codes in this field.
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="code">Code</label>
            <input name="code" type="text"
              value={this.state.code}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              required
              minLength={1}/>
            <p className="hint">
              The gift card code being offered by this gift card, i.e. "5off25".
              Enter this <strong>EXACTLY</strong> as provided by the vendor.
            </p>
          </div>
          <div className="input-group">
            <label htmlFor="image">Gift Card Image</label>
            <input name="image" type="file" required />
            <p className="hint">
              This is the image of the gift card given to show attendees.
            </p>
          </div>
          <div className="button-group">
            <button type="submit" className="btn btn-success">
              <FontAwesome name="save"/>
              Save Gift Card
            </button>
          </div>
        </form>
      </EditorDialog>
    );
  }
}

CreateGiftCardDialog.propTypes = {
  exhibitors: PropTypes.array.isRequired,
  dataURL: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/create-gift-card-dialog.js